import React from 'react';

const pipeStyles = {
  display: 'inline-block',
  margin: '0 8px'
};

const Pipe = () => <span style={pipeStyles}>|</span>;

export default Pipe;
